export {
  openSqliteDatabase,
  type SQLiteDatabase,
  type SQLiteOpenOptions,
} from "#open-sqlite-database";
export {
  isDatabaseClosingError,
  makeCloseSafeSqliteConnection,
} from "#make-close-safe-sqlite-connection";
export { openActorTursoSyncConnection } from "#open-actor-turso-sync-connection";
// Native-only helpers for the single-file actor database: the signed-out LOCAL open,
// and the file operations sign-in / sign-out / sign-up need (wipe, move aside).
export {
  openActorTursoLocalConnection,
  type ActorTursoLocalConnection,
} from "#open-actor-turso-local-connection";
export { wipeTursoDatabaseFiles } from "#wipe-turso-database-files";
export {
  hasTursoDatabaseFiles,
  hasLocalTursoDatabase,
  listTursoDatabaseDirectory,
  relocateTursoDatabaseFiles,
  resolveTursoDatabasePath,
} from "#relocate-turso-database-files";
export { resolveSqlitePath, toFileUri } from "#resolve-sqlite-path";
export {
  createActorSyncConnectionLock,
  type ActorSyncConnectionLock,
} from "#actor-sync-connection-lock";
export {
  ActorSyncPullTimeoutError,
  createLockedActorTursoSync,
  pullWithTimeout,
  type TwoPhaseTursoSyncDatabase,
} from "#lock-turso-sync-phases";
export type {
  ActorTursoSyncConnection,
  ActorTursoSyncOptions,
  ActorTursoSyncStats,
} from "#open-actor-turso-sync-connection-types";
export type { ActorSyncGatewayAnswer } from "#actor-sync-fetch";
export {
  type ActorSyncRefusal,
  ActorSyncRefusedError,
  readActorSyncRefusal,
} from "#actor-sync-refusal";
export { SyncedSchemaWriteError } from "#turso-adapter";
// Installed once from app startup (`sentry-setup`) so stuck-lock reports reach Sentry on the MAIN
// THREAD. Deliberately injected rather than imported by the watchdog itself: the watchdog is in the
// OPFS leader worker's bundle, and a static Sentry import drags varlock — and its unguarded
// `process.env` read — into a Web Worker that has no `process`. See the header of
// `report-stuck-connection-lock.ts`.
export { installStuckLockReporter, type StuckLockReporter } from "#report-stuck-connection-lock";
export {
  actorBackupTableSql,
  hasActorBackupSnapshotReader,
  hasActorBackupSnapshotSource,
  type ActorBackupSnapshotReader,
  type ActorBackupSnapshotSource,
  type ActorBackupSnapshotState,
} from "#actor-backup-reader";

export type {
  ActorBackupRestoreOptions,
  ActorBackupRestoreStatement,
} from "#actor-backup-reader";

export { runOwnedSqliteTransaction } from "#run-owned-sqlite-transaction";
export { purgeNativeDatabases, retireNativeDatabases } from "#native-database-generations";
export { nativeActorReplicaName, readActorReplicaExport } from "#read-actor-replica-export";
export {
  type ActorReplicaExport,
  type ActorSyncExport,
  exportActorReplica,
  exportActorSyncChanges,
} from "#export-actor-sync-changes";
export { DatabaseRecoveryRequiredError, isDatabaseCorruption } from "#database-corruption-error";
export { getLeaderOpenTrace, subscribeLeaderOpenTrace } from "#leader-open-trace";
